import React from 'react'
import { message } from 'antd';

import { connect } from 'react-redux'
import { reduxForm, submit, change, initialize, getFormValues } from 'redux-form'

import {defaultExpenseCategories} from './categories.js'
import { Select } from 'antd';
import { AutoComplete, Row, Col, Icon as AIcon, Input } from 'antd';
import { CategoryIcon, EditIcon, TrashIcon, FolderIcon, ShopIcon, NoteIcon, CalendarIcon, CarIcon, Icon, BackIcon, FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon } from '../icons'

const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;


function renderTitle(title) {
  return (
    <span>
      {title}
      {/* <a
        style={{ float: 'right' }}
        href="/account/favorite-places"
      >
        manage / add
      </a> */}
    </span>
  );
}



const customOptions = (data, remove)=>
  [<OptGroup
      key={'custom'}
      label={renderTitle('Custom:')}
    >
    {
      data.map((opt,i) => (
        <Option
          key={i}
          value={opt} data={opt} title={opt}
        >
          <Row type="flex"
            style={{width:'100%'}}
            >
            <Col>
              <CategoryIcon type={'Custom'}/>
            </Col>
            <Col>
              {opt}
            </Col>
            <Col onClick={(e)=>remove(e, opt)} style={{float:'right'}} span={3}>
              <AIcon type="delete" style={{color:'red', opacity: .8, fontWeight: 0}}/>
            </Col>

          </Row>
        </Option>
      ))
    }
  </OptGroup>]

const defaultOptions = (data)=>
  [<OptGroup
      key={'results'}
      label={renderTitle('Default:')}
    >
    {
      data.map((opt,i) => (
        <Option
          key={i}
          value={opt} data={opt} title={opt}
        >
          <Row type="flex">
            <Col>
              <CategoryIcon type={opt}/>
            </Col>
            <Col>
              {opt}
            </Col>

          </Row>
        </Option>
      ))
    }
  </OptGroup>]


const newOption = (data)=>
  [<OptGroup
      key={'New'}
      label={renderTitle('Add new category:')}
    >
    {
      data.map((opt,i) => (
        <Option
          key={i}
          value={opt} data={opt} title={opt}
        >
          <Row type="flex">
            <Col>
              <AIcon type="edit" style={{ fontWeight: 0, opacity:.8}}/>
            </Col>
            <Col>
              {opt}
            </Col>

          </Row>
        </Option>
      ))
    }
  </OptGroup>]

class Picker extends React.Component {
  addIfNeeded = (value) => {
    if (this.props.custom_expense_categories.includes(value)) return

    if (this.props.categories.includes(value)) return

    return this.props.onUpdateCustomExpenseCategories(
      [...this.props.custom_expense_categories, value]
    )

  }
  remove = (value, key) => {
    value.stopPropagation()
    this.props.onUpdateCustomExpenseCategories(
      this.props.custom_expense_categories.filter(v=>v!==key)
    )

    // re-render dataSource:
    this.setState(prevState=>({
      dataSource: [
        ...customOptions(this.props.custom_expense_categories.filter(v=>v!==key), this.remove),
        ...defaultOptions(this.props.categories)
      ]
    }));

  }

  constructor(props) {
    super(props);
    this.state = {
      data: props.custom_expense_categories,
      dataSource: [],
      customExpenseCategories: props.custom_expense_categories
    };
  }

  componentDidMount() {
    this.setState({

      dataSource: [
        ...customOptions(this.props.custom_expense_categories, this.remove),
        ...defaultOptions(this.props.categories)
      ]

    })

  }

  handleSearch = (value) => {
    if (value.trim().length>0) {

        value && this.setState({
          dataSource: [
            ...newOption([value]),
            ...customOptions(this.props.custom_expense_categories, this.remove),
            ...defaultOptions(this.props.categories),
          ],
        });

    } else {
      this.setState({
        dataSource: [
          ...customOptions(this.props.custom_expense_categories, this.remove),
          ...defaultOptions(this.props.categories)
        ],
      });
    }
  }

  render() {
    return (

        <AutoComplete
          size="large"
          allowClear
          dataSource={this.state.dataSource}
          onSearch={this.handleSearch}
          // dropdownMatchSelectWidth={false}
          placeholder="Search or add category"
          optionLabelProp="value"
          onSelect={(v)=>{
            this.addIfNeeded(v)
            this.props.onSelect(v)
          }}
          defaultValue={this.props.defaultValue}
          key={this.props.defaultValue} // needed for defaultValue to be initially populated (controlled component)
          filterOption={(inputValue, option) =>
            option.props.children.props.children[1].props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }

        >
          <Input
            // size="large" //doesn't work so inline style override
            style={{height: 42, marginTop: -9}}
          />
        </AutoComplete>


    );
  }
}

export default Picker



// WEBPACK FOOTER //
// ./src/core/CategoryPicker/Picker.jsx